import React, { Component } from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import { FormFooter } from '@atlaskit/form';
import { Grid, GridColumn } from '@atlaskit/page';
import ContentWrapper from '../../components/ContentWrapper';
import { connect } from 'react-redux';
import FirmwareActions from '../../redux/FirmwareRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import { FirmwareFields } from './components/FirmwareForm';
import Forbidden from '../../components/Forbidden';
import { withTranslation, Trans } from 'react-i18next';

class CreateFirmwarePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data : null,
      firmware: {
        name: '',
        version: '',
        applicability: null,
        applicabilityId: null,
        status: null,
        statusId: null,
      },
      file : null,
      errors: {}
    };
  }

  componentDidUpdate(prevProps) {
    const { file } = this.state;
    const { uploadFile, firmware } = this.props;

    if (
      prevProps.fetching !== this.props.fetching &&
      prevProps.fetching &&
      !this.props.error &&
      firmware &&
      firmware.id
    ) {
      if (file) {
         uploadFile(firmware.id, this.state.file);
      }
      
      this.props.history.goBack();
    }
  }

  onCancel = e => {
    e.preventDefault();
    this.props.history.goBack();
  };

  onFormSubmit = e => {
    e.preventDefault();
    const { create } = this.props;
    const { file, firmware } = this.state;

    const errors = this.validateForm();
    
    this.setState({errors: errors});


    if (firmware && file) {
        create(this.state.firmware );
    }
  };


  onFileChange = e => {
    const file = e.target.files[0];
    this.setState({
      file:  file,
    });
  };

  validateForm = () => {
    const { firmware, file } = this.state;
    const {t} = this.props;
    const errors = {};

    if (!firmware.status) {
      errors.status = `${t('Status')} ${t('Is required')}`;
    }
    if (!firmware.applicability) {
      errors.applicability = `${t('Applicability')} ${t('Is required')}`;
    }
    if (!file) {
      errors.file = `${t('File')} ${t('Is required')}`;
    }
  
    return errors;
  };

  onChange = (name, value) => {
    this.setState({
      firmware: { ...this.state.firmware, [name]: value },
    });
    
    if (name === 'status') {
      this.setState(prevState => ({
        firmware: {
          ...prevState.firmware,
          statusId: value.id // Сохраняем только id
        },
      }));
    } 

    if (name === 'applicability') {
      this.setState(prevState => ({
        firmware: {
          ...prevState.firmware,
          applicabilityId: value.id // Сохраняем только id
        },
      }));
    } 
  };

  render() {
    const { firmware, file, errors } = this.state;
    const { fetching, dictionaries, getDictionaries, permissions , t } = this.props;

     if (!permissions.create) {
         return <Forbidden />;
     }

    return (
      <ContentWrapper>
        <h1>{t('Create new firmware')}</h1>
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <FirmwareFields
              {...firmware}
              onChange={this.onChange}
              onFileChange={this.onFileChange}
              dictionaries={dictionaries}
              getDictionaries={getDictionaries}
              fetching={fetching}
              file={file}
              errors={errors}
              permissions={permissions}
            />
            <GridColumn>
              <FormFooter>
                <ButtonGroup>
                  <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                    <Trans>Cancel</Trans>
                  </Button>
                  <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
                    <Trans>Create</Trans>
                  </Button>
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.firmware,
    firmware: state.firmware.firmware,
    fetching: state.firmware.fetching,
    error: state.firmware.error,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    create: data => dispatch(FirmwareActions.firmwareAddRequest(data)),
    uploadFile: (id, formData) => dispatch(FirmwareActions.firmwareFileAddRequest(id, formData)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('fota')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateFirmwarePage));